import {ProviderType} from '../store/types';

export const isOrganization = (type: string | undefined) =>
  typeof type !== 'undefined' && type.toLowerCase() === ProviderType.ORGANIZATION
